var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.264 19.552c0 3.648 2.4 5.568 5.088 5.568 2.976 0 5.76-2.496 5.76-5.664 0-2.592-1.824-4.32-4.032-4.32h-.768c1.056-3.072 4.512-6.336 8.064-8.064L26.4 4c-5.952 2.976-11.136 9.504-11.136 15.552zM0 19.552C0 23.2 2.304 25.12 5.088 25.12c2.976 0 5.76-2.496 5.76-5.664 0-2.592-1.92-4.32-4.128-4.32h-.768c1.056-3.072 4.608-6.336 8.064-8.064L11.136 4C5.184 6.976 0 13.504 0 19.552z"
  })));
}

export default SvgQuote;